import React, { useState, useEffect } from 'react';
import {
    Box, Card, CardContent, Typography, Autocomplete, TextField, Button, CircularProgress,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
} from '@mui/material';
import * as XLSX from 'xlsx';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from '../../App';

const MediatorReport = () => {

    const [zone, setZone] = useState(null);
    const [branch, setBranch] = useState(null);
    const [category, setCategory] = useState(null);
    const [customType, setCustomType] = useState(null);
    const [type, setType] = useState(null);

    const [zones, setZones] = useState([]);
    const [branches, setBranches] = useState([]);
    const [categories, setCategories] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const login_id = localStorage.getItem("LOGIN_ID");
    const usertype = localStorage.getItem("usertype");
    const user_branch = localStorage.getItem("BRANCH_CODE");
    const customTypes = [

        { label: 'ISSUED', value: 'ISSUED' },
        { label: 'DESPATCH', value: 'DESPATCH' }
    ];

    const types = [
       
        { label: 'DESPATCH', value: 'DESPATCH' },
        { label: 'NON DESPATCH', value: 'NON DESPATCH' }
    ];

    
    const fetchZones = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/loadZone`);
            if (res.data && res.data.length > 0) {
                setZones(res.data.map(item => ({
                    label: item.label || 'Unknown',
                    value: item.value
                })));
            }
        } catch (error) {
            console.error('Error fetching zones:', error);
            //Swal.fire('Error', 'Failed to load zones', 'error');
        }
    };

    // const fetchBranches = async () => {
    //     try {
    //         const res = await axios.post(`${BASE_URL}/fillBranchformediator`);
    //         if (res.data && res.data.length > 0) {
    //             setBranches(res.data.map(item => ({
                    
    //                 label: item.branchName, 
    //                 value: item.branchId
    //             })));
    //         }
    //     } catch (error) {
    //         console.error('Error fetching branches:', error);
    //         Swal.fire('Error', 'Failed to load branches', 'error');
    //     }
    // };
    const fetchBranches = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/fillBranchformediator`, {
                user_branch: user_branch,
                login_id: login_id
            });
            
            
            if (res.data && res.data.branches && res.data.branches.length > 0) {
                setBranches(res.data.branches.map(item => ({
                    label: item.BRANCH_NAME,    // Correct key mapping
                    value: item.BRANCH_CODE     // Correct key mapping
                })));
            }
        } catch (error) {
            console.error('Error fetching branches:', error);
           // Swal.fire('Error', 'Failed to load branches', 'error');
        }
    };
    
    const fetchCategories = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/fillCategory`);
            if (res.data && res.data.length > 0) {
                setCategories(res.data.map(item => ({
                    label: item.value || 'Unknown',
                    value: item.text
                })));
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
            Swal.fire('Error', 'Failed to load categories', 'error');
        }
    };

   
    // const fetchData = async () => {
    //     if (
    //         !zone?.value?.trim() || 
    //         !branch?.value?.trim() || 
    //         !category?.value?.trim() || 
    //         !type?.value?.trim() || 
    //         !customType?.value?.trim()
    //     ) {
    //         Swal.fire('Warning', 'Please select all filters', 'warning');
    //         return;
    //     }
        
    
    //     setLoading(true);
    
    //     const issuedValue = customType.value === 'ISSUED' ? 1 : 0;
    //     const despatchValue = type.value === 'DESPATCH' ? 1 : 0;
    
    //     try {
    //         const res = await axios.post(`${BASE_URL}/loadGridReport`, {
    //             zone_id: zone.value,
    //             branch_id: branch.value,
    //             category_id: category.value,
    //             issued: issuedValue,        
    //             despatch: despatchValue      
    //         });
    
    //         setData(res.data);
    //         Swal.fire('Success', 'Data loaded successfully!', 'success');
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //         Swal.fire('Error', 'Failed to fetch data', 'error');
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    const fetchData = async () => {
        const zoneValue = zone?.value || 'ALL';
        const branchValue = branch?.value || 'ALL';
        const categoryValue = category?.value || 'ALL';
        const typeValue = type?.value || 'ALL';
        const customTypeValue = customType?.value || 'ALL';
    
        if (!zoneValue || !branchValue || !categoryValue || !typeValue || !customTypeValue) {
            Swal.fire('Warning', 'Please select all filters', 'warning');
            return;
        }
    
        setLoading(true);
    
        const issuedValue = customTypeValue === 'ISSUED' ? 1 : 0;
        const despatchValue = typeValue === 'DESPATCH' ? 1 : 0;
    
        try {
            const res = await axios.post(`${BASE_URL}/loadGridReport`, {
                zone_id: zoneValue,
                branch_id: branchValue,
                category_id: categoryValue,
                issued: issuedValue,
                despatch: despatchValue
            });
    
            const responseData = res.data.data || [];
    
            if (responseData.length === 0) {
                setLoading(false);
                Swal.fire('Warning', 'No data found', 'warning');
                return;
            }
    
            // Convert data to Excel format
            const worksheet = XLSX.utils.json_to_sheet(responseData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Mediator_Report');
    
            // Trigger Excel download
            XLSX.writeFile(workbook, `Mediator_Report.xlsx`);
            //Swal.fire('Success', 'Excel exported successfully!', 'success');
    
           // setData(responseData);
        } catch (error) {
            console.error('Error fetching data:', error);
            Swal.fire('Info', 'Failed to fetch data', 'info');
        } finally {
            setLoading(false);
        }
    };
    
    
    
  
    const exportToExcel = () => {
        if (data.length === 0) {
            Swal.fire('Warning', 'No data to export', 'warning');
            return;
        }

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Mediator_Report');

        XLSX.writeFile(workbook, `Mediator_Report.xlsx`);
        Swal.fire('Success', 'Excel exported successfully!', 'success');
    };


    useEffect(() => {
        fetchZones();
        fetchBranches();
        fetchCategories();
    }, []);

    return (
        <Box display="flex" flexDirection="column" alignItems="center" sx={{ minHeight: '100vh', backgroundColor: '#f0f0f0', padding: 3 }}>
            <Card sx={{ width: '90%', maxWidth: 1200, boxShadow: 3, padding: 3, marginBottom: 3 }}>
                <CardContent>
                    <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', fontWeight: 'bold', color: '#1976d2' }}>
                        {/* Mediator Report */}
                    </Typography>

                    <Box display="flex" justifyContent="space-between" sx={{ marginTop: 3 }}>
                        <Autocomplete
                            options={zones}
                            value={zone}
                            onChange={(event, newValue) => setZone(newValue)}
                            getOptionLabel={(option) => option.label}
                            renderInput={(params) => <TextField {...params} label="Select Zone" />}
                            sx={{ width: '18%' }}
                        />
<Autocomplete
    options={branches}
    getOptionLabel={(option) => `${option.value} - ${option.label}`}
    renderInput={(params) => (
        <TextField {...params} label="Select Branch" variant="outlined" />
    )}
    onChange={(event, newValue) => console.log(newValue)}
    sx={{ width: '18%' }}
/>


                        <Autocomplete
                            options={categories}
                            value={category}
                            onChange={(event, newValue) => setCategory(newValue)}
                            getOptionLabel={(option) => option.label}
                            renderInput={(params) => <TextField {...params} label="Select Category" />}
                            sx={{ width: '18%' }}
                        />

                        <Autocomplete
                            options={customTypes}
                            value={customType}
                            onChange={(event, newValue) => setCustomType(newValue)}
                            getOptionLabel={(option) => option.label}
                            renderInput={(params) => <TextField {...params} label="Select Custom Type" />}
                            sx={{ width: '18%' }}
                        />

                        <Autocomplete
                            options={types}
                            value={type}
                            onChange={(event, newValue) => setType(newValue)}
                            getOptionLabel={(option) => option.label}
                            renderInput={(params) => <TextField {...params} label="Select Type" />}
                            sx={{ width: '18%' }}
                        />
                    </Box>

                    <Box display="flex" justifyContent="center" sx={{ marginTop: 3 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={fetchData}
                            sx={{ marginRight: 2 }}
                            disabled={loading}
                        >
                            {loading ? <CircularProgress size={24} color="inherit" /> : 'Report'}
                        </Button>

                        {/* <Button
                            variant="contained"
                            color="success"
                            onClick={exportToExcel}
                            disabled={data.length === 0}
                        >
                            Export to Excel
                        </Button> */}
                    </Box>
                </CardContent>
            </Card>

            {data.length > 0 && (
                <Card sx={{ width: '90%', maxWidth: 1200, boxShadow: 3, padding: 3, marginTop: 3 }}>
                    <CardContent>
                        <Typography variant="h6" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                            Report Data
                        </Typography>

                        <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
    <Table stickyHeader>
        <TableHead>
        
    <TableRow sx={{ backgroundColor: '#add8e6' }}>  
        <TableCell sx={{backgroundColor: '#add8e6', color: 'black', fontWeight: 'bold' }}>Branch Code</TableCell>
        <TableCell sx={{backgroundColor: '#add8e6', color: 'black', fontWeight: 'bold' }}>Dealer Code</TableCell>
        <TableCell sx={{backgroundColor: '#add8e6', color: 'black', fontWeight: 'bold' }}>Dealer Name</TableCell>
        <TableCell sx={{backgroundColor: '#add8e6', color: 'black', fontWeight: 'bold' }}>Dealer Category</TableCell>
        <TableCell sx={{backgroundColor: '#add8e6',color: 'black', fontWeight: 'bold' }}>Mechanic Code</TableCell>
        <TableCell sx={{backgroundColor: '#add8e6', color: 'black', fontWeight: 'bold' }}>Mechanic Name</TableCell>
        <TableCell sx={{backgroundColor: '#add8e6', color: 'black', fontWeight: 'bold' }}>Residential Address</TableCell>
        <TableCell sx={{backgroundColor: '#add8e6', color: 'black', fontWeight: 'bold' }}>Mobile</TableCell>
        <TableCell sx={{backgroundColor: '#add8e6', color: 'black', fontWeight: 'bold' }}>DMS Status</TableCell>
        <TableCell sx={{backgroundColor: '#add8e6', color: 'black', fontWeight: 'bold' }}>ID Card Issued</TableCell>
        <TableCell sx={{backgroundColor: '#add8e6', color: 'black', fontWeight: 'bold' }}>ID Card Issued Date</TableCell>
        <TableCell sx={{backgroundColor: '#add8e6', color: 'black', fontWeight: 'bold' }}>Tollfree Activation</TableCell>
        <TableCell sx={{backgroundColor: '#add8e6', color: 'black', fontWeight: 'bold' }}>Activation Date</TableCell>
    </TableRow>
</TableHead>

        <TableBody>
            {data.map((item, index) => (
                <TableRow key={index}>
                    <TableCell>{item.branch_code}</TableCell>
                    <TableCell>{item.dealer_code}</TableCell>
                    <TableCell>{item.dealer_name}</TableCell>
                    <TableCell>{item.dealer_category || '-'}</TableCell>
                    <TableCell>{item.MECHANIC_CODE}</TableCell>
                    <TableCell>{item.mechanic_name}</TableCell>
                    <TableCell>{item.residential_address}</TableCell>
                    <TableCell>{item.mobile}</TableCell>
                    <TableCell>{item.DMS_STATUS}</TableCell>
                    <TableCell>{item.id_card_issued}</TableCell>
                    <TableCell>{item.id_card_issued_date}</TableCell>
                    <TableCell>{item.TOLLFREE_ACTIVATION}</TableCell>
                    <TableCell>{item.activation_date}</TableCell>
                </TableRow>
            ))}
        </TableBody>
    </Table>
</TableContainer>


                    </CardContent>
                </Card>
            )}
        </Box>
    );
};

export default MediatorReport;
